// This concept is frontend-only at the moment. You will probably not find it in backend or IoT layer.
export enum HubType {
  CONSOLIDATED_WIRELESS_DEVICE = 'consolidated wireless device',
  LITE = 'lite',
  MONITOR = 'monitor',
  TROUGH_DIRECT = 'trough direct'
}

/**
 * A non-consolidated wireless device does NOT appear as a "Device" in Enterprise Settings.
 * Its ID is not known to frontend either.
 */
export const NON_CONSOLIDATED_WIRELESS_DEVICE_ID = -1;
